// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pe_a bhs_sn bhs_sv bhs_sw bhs_kx bhs_ky bhs_ke undefined bhs_vt"};